import { IKreditsFilters } from 'features/Kredits/views/Index/Filters/types'
import { BusinessClientSuggestion } from 'gql/generated/graphql'
import {
  GTBusinessSiteSuggestion,
  GTKreditAccountType,
  GTKreditTransaction,
  GTKreditTransactionType,
  GTKreditsInput,
  GTTransactionSource,
  GTTransactionSourceBooking,
  GTTransactionSourceMobileLine,
  GTTransactionSourceSale
} from 'gql/types.generated'
import { isEmpty } from 'lodash'
import { getQueryString } from 'utils/route'

export const mapFiltersToSearchQueryString = (filters: IKreditsFilters, pageNb = 1): string => {
  return getQueryString({
    userFullName: filters.userFullName,
    phone: filters.phone,
    email: filters.email,
    siteId: filters.site.id,
    clientId: filters.client.id,
    category: filters.category,
    page: pageNb
  })
}

export const mapFiltersToQueryVariables = (filters: IKreditsFilters): GTKreditsInput => {
  return {
    userFullName: filters.userFullName || undefined,
    phone: filters.phone || undefined,
    email: filters.email || undefined,
    businessClientID: filters.client.id || undefined,
    businessSiteID: filters.site.id || undefined,
    category: !isEmpty(filters.category) ? parseInt(filters.category) : undefined
  }
}

export const mapSearchToFiltersForm = (
  queries: Record<string, string | undefined>,
  businessClient: BusinessClientSuggestion | null,
  businessSite: GTBusinessSiteSuggestion | null
): IKreditsFilters => {
  return {
    userFullName: queries.userFullName || '',
    phone: queries.phone || '',
    email: queries.email || '',
    site: businessSite || {
      id: '',
      name: ''
    },
    client: businessClient || {
      id: '',
      name: ''
    },
    category: queries.category || ''
  }
}

export const KreditTransactionUtils = {
  isDeposit(transaction: GTKreditTransaction): boolean {
    return transaction.type === GTKreditTransactionType.Deposit
  },
  isWithdrawal(transaction: GTKreditTransaction): boolean {
    return transaction.type === GTKreditTransactionType.Withdrawal
  },
  isRefund(transaction: GTKreditTransaction): boolean {
    return transaction.type === GTKreditTransactionType.Refund
  },
  isBookingSource(source: GTTransactionSource): boolean {
    return !isEmpty((source as GTTransactionSourceBooking)?.bookingID)
  },
  isSaleSource(source: GTTransactionSource): boolean {
    return (source as GTTransactionSourceSale)?.salesChannelID === process.env.POS_MX_SALES_CHANNEL_ID
  },
  isMobileLineSource(source: GTTransactionSource): boolean {
    return !isEmpty((source as GTTransactionSourceMobileLine)?.number)
  },
  isKolorsKreditsTransaction(transaction: GTKreditTransaction): boolean {
    return (
      transaction.accounts?.find(
        (account) => account === GTKreditAccountType.TopUp || account === GTKreditAccountType.Refund
      ) !== undefined
    )
  },
  isBonusTransaction(transaction: GTKreditTransaction): boolean {
    return transaction.accounts?.find((account) => account === GTKreditAccountType.Bonus) !== undefined
  },
  isCorporateKreditsTransaction(transaction: GTKreditTransaction): boolean {
    return transaction.accounts?.find((account) => account === GTKreditAccountType.Corporate) !== undefined
  }
}
